exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_option_2T9IFVD0X_4E3KVBU5835K {\n  width: 100%;\n  height: 30px;\n}\n\n.IA_icon_3wsDFM_V9w9mRNTocjrHtA {\n  float: left;\n}\n\n.IA_label_1NjQ1C8KUYqlSmDGbYjULu {\n  float: left;\n  margin-left: 10px;\n  line-height: 30px;\n}", ""]);

// Exports
exports.locals = {
	"IA_option": "IA_option_2T9IFVD0X_4E3KVBU5835K",
	"IA_icon": "IA_icon_3wsDFM_V9w9mRNTocjrHtA",
	"IA_label": "IA_label_1NjQ1C8KUYqlSmDGbYjULu"
};